import { GetterTree } from 'vuex';

import { IAudioPlayerState } from './audio-player-types.store';

export const getters: GetterTree<IAudioPlayerState, any> = {
    audioUrl: (state: IAudioPlayerState) => state.audioUrl,
    title: (state: IAudioPlayerState) => state.title,
    isShow: (state: IAudioPlayerState) => state.isShow,
    recordId: (state: IAudioPlayerState) => state.recordId,
    isPlaying: (state: IAudioPlayerState) => state.isPlaying
}   